import { isLoading } from 'conversations-async-data/async-data/operators/statusComparators';
import { getData } from 'conversations-async-data/async-data/operators/getters';
import { useThreadDetails } from 'conversations-thread-view/thread-details-feature/public/hooks/useThreadDetails';
//@ts-expect-error module not typed
import { provideThreadView } from 'conversations-thread-view/thread-view/decorators/provideThreadView';
//@ts-expect-error module not typed
import { useThreadHistory } from 'conversations-thread-view/thread-histories/hooks/useThreadHistory';
import { BaseReplyEditor } from './BaseReplyEditor';
import { ReplyEditorLoadingState } from './ReplyEditorLoadingState';
import { withRichTextEditorMetrics } from '../../../metrics/protected/wrappers';
import { THREAD_COMMENT } from 'conversations-message-history/comment-message/constants/messageTypes';
import { geConfigKeyFromUrlFragment } from '../../../editor-utilities/protected/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const noop = () => {};
/**
 * @description The application-facing interface for
 * common message reply editing + submission.
 */
const _ReplyEditor = ({
  allowFullscreen,
  associatedObjectId,
  associatedObjectTypeId,
  disableCalling = false,
  callingSource = '',
  disabled = false,
  disabledMessage,
  editorFragment = '',
  onChannelChange = noop,
  onDraftChange = noop,
  renderExistingFileSelect = () => null,
  threadId,
  isKnownVisitor = false,
  renderSubmitButton,
  replyRecommendationsEnabled,
  hideComments = false,
  CustomHeaderActions,
  defaultSendFromEnabled,
  customEditorViews,
  macrosMenuConfig,
  handleFirstClick,
  threadContext
}) => {
  const {
    asyncThreadDetails
  } = useThreadDetails({
    threadId
  });
  const threadDetails = getData(asyncThreadDetails);
  const {
    asyncThreadHistory
  } = useThreadHistory({
    threadId
  });
  const threadHistory = getData(asyncThreadHistory);
  if (isLoading(asyncThreadHistory) || isLoading(asyncThreadDetails) || !threadDetails || !threadHistory) {
    return /*#__PURE__*/_jsx(ReplyEditorLoadingState, {});
  }
  const isCommentFragment = geConfigKeyFromUrlFragment({
    fragment: editorFragment,
    customViewFragmentMap: (customEditorViews === null || customEditorViews === void 0 ? void 0 : customEditorViews.fragmentMap) || {}
  }) === THREAD_COMMENT;
  const filteredEditorFragment = hideComments && isCommentFragment ? '' : editorFragment;
  const otherProps = {
    allowFullscreen,
    associatedObjectId,
    associatedObjectTypeId,
    disableCalling,
    callingSource,
    disabled,
    disabledMessage,
    editorFragment: filteredEditorFragment,
    onChannelChange,
    onDraftChange,
    renderExistingFileSelect,
    threadId,
    isKnownVisitor,
    renderSubmitButton,
    replyRecommendationsEnabled,
    hideComments,
    defaultSendFromEnabled,
    customEditorViews,
    macrosMenuConfig,
    handleFirstClick,
    threadContext
  };
  return /*#__PURE__*/_jsx(BaseReplyEditor, Object.assign({
    threadDetails: threadDetails,
    threadHistory: threadHistory,
    CustomHeaderActions: CustomHeaderActions
  }, otherProps));
};
_ReplyEditor.displayName = 'ReplyEditor';
export const ReplyEditor = withRichTextEditorMetrics('reply', provideThreadView(_ReplyEditor), ['threadId']);
ReplyEditor._WrappedComponent = _ReplyEditor;